import { Comparison as Comparison_phosphor } from './Comparison.phosphor';
import { Comparison as Comparison_zoomg } from './Comparison.zoomg';
import { Comparison as Comparison_zoomit } from './Comparison.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'zoomg':
      return Comparison_zoomg;

    case 'phosphor':
      return Comparison_phosphor;

    default:
      return Comparison_zoomit;
  }
};

export const Comparison = IconRenderer();
